/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'

import { getApiTargetInfo, ExportComponent, UnitSelection } from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import moment from 'moment'
import {
  UnitSelectionContext,
  DatePickerContext,
  ErrorContext,
  SpinContext,
} from 'context'

import {
  getUtilityNameMap,
  getUnitNameMap,
  getPermitActions,
  getValidYearRange,
  getClientInfo,
} from 'core/selectors'

import { CriteriaRow, Title, Content, FullHeightSizer } from 'core/screen-util'
import { rowHeaderRender, exportDataComponent } from 'core/utils'
import {
  Button,
  Input,
  DatePicker,
  Empty,
  message,
  Popconfirm,
  Upload,
} from 'antd'
import * as freeEditEngine from '@integec/grid-tools/lib/editEngine'

import Grid, {
  defaultVirtualizedCellRender,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import * as Actions from 'core/EventActions'
import JcTmpErrorDialog, {
  isErrorContains,
} from 'core/component/JcTmpErrorDialog'
import {
  getAuthorization,
  getCredentials,
  // getSystemConfigurationInfo,
} from 'api/pgads'
class CommonScreen extends React.Component {
  constructor(props) {
    super(props)

    this.GridRef = React.createRef()
  }

  state = {
    data: [],
    // loading: false,
    editInfo: freeEditEngine.generateInitialEditInfo(),
    fuzzyFilter: '',
    selected: { selectedRows: [] },
    insertData: this.props.defaultInsertData || {},
    errorData: [],
    systemIsImport: false,
  }

  setInsertData = insertData => {
    this.setState({ insertData })
  }

  selectionChange = selected => {
    this.setState({ selected })
  }

  setErr = err => {
    // this.setState({ err })
    // this.setLoading(false)
    this.props.setError(err)
  }

  setLoading = loading => {
    // this.setState({ loading: loading || false })
    this.props.setSpinning(loading || false)
  }

  componentDidMount() {
    if (this.props.autoRetrieve)
      this.onRetrieve({ autoRetrieve: this.props.autoRetrieve })
  }

  onRetrieve = ({
    selectedUnits,
    setVisibleUnitSelection,
    autoRetrieve,
    selectedDate,
  }) => {
    if (
      !autoRetrieve &&
      this.props.withUnitSelection &&
      selectedUnits.length <= 0
    ) {
      message.error('Please , Select Unit')
      setVisibleUnitSelection(true)
      return
    }

    const isValid = this.props.beforeRetrieveValidation
      ? this.props.beforeRetrieveValidation(
          this.props,
          this.state,
          selectedUnits
        )
      : true
    if (!isValid) return

    const { apiTargetInfo, retrieveTask } = this.props
    if (!autoRetrieve) setVisibleUnitSelection(false)

    let retrieveTaskData = retrieveTask(apiTargetInfo)
    if (this.props.withCriteria)
      retrieveTaskData = retrieveTaskData(
        this.props.withCriteria(
          this.state,
          this.props,
          selectedUnits,
          selectedDate
        )
      )
    this.setLoading(true)
    retrieveTaskData.fork(this.props.setError, data => {
      this.setLoading(false)
      data = this.props.sortOnData ? this.props.sortOnData(data) : data
      this.setState({
        data,
        editInfo: freeEditEngine.generateInitialEditInfo(),
        selected: { selectedRows: [] },
      })
      this.props.onRetrieveData && this.props.onRetrieveData(data)
    })
  }

  onInsert = (/* {  selectedUnits, setVisibleUnitSelection, autoRetrieve } */) => {
    const { editInfo } = this.state
    const newInfo = {
      ...editInfo,
      added: [
        ...editInfo.added,
        { inserted: true, modificationInfo: { user: null, modDate: moment() } },
      ],
    }
    this.setState({ editInfo: newInfo, enterNew: true })
  }

  onCriteriaChnage = _ => {
    this.setState({
      data: [],
      editInfo: freeEditEngine.generateInitialEditInfo(),
    })
    this.props.onCriteriaChange && this.props.onCriteriaChange()
    this.setLoading(false)
  }

  validateData = data => {
    if (this.props.skipValidation === true) return true

    const insertData = data || this.state.insertData
    const pkKey = this.props.header
      .filter(
        h =>
          (h.isKey || h.isRequired) &&
          h.ident !== 'modifier' &&
          h.ident !== 'modifiedDate'
      )
      .map(h => h.ident)
    const insertPkEmptyFilter = pkKey.filter(
      e =>
        insertData[e] === undefined ||
        insertData[e] === 'Invalid date' ||
        (insertData[e] + '').length <= 0
    )
    if (insertPkEmptyFilter.length > 0) {
      message.error(
        `Some of required field are null : ${insertPkEmptyFilter
          .map(e => this.props.header.find(h => h.ident === e))
          .map(e => e.display)
          .join(', ')}`,
        4
      )
      return false
    }

    const pkProps = this.props.header
      .filter(
        h => h.isKey && h.ident !== 'modifier' && h.ident !== 'modifiedDate'
      )
      // .map(h => h.ident)
      .map(r => R.propEq(r.ident, insertData[r.ident]))

    if (this.state.data.find(d => R.allPass(pkProps)(d))) {
      message.error(
        'Record with Same Key exists, To update the record, click on the record in the table.',
        4
      )
      return false
    }
    return true
  }

  onAdd = ({
    selectedUnits,
    setVisibleUnitSelection,
    autoRetrieve,
    showInsertComp,
    selectedDate,
  }) => {
    const { apiTargetInfo, saveTask, afterSaveTask } = this.props

    if (!this.validateData()) return

    if (this.props.insertValidation) {
      if (!this.props.insertValidation(this.state.insertData, this.state.data))
        return
    }
    const insertData = this.props.beforeInsertData
      ? this.props.beforeInsertData(this.state.insertData)
      : this.state.insertData

    saveTask(apiTargetInfo)([{ ...insertData, isInsert: true }]).fork(
      this.props.setError,
      jcTmpErrorList => {
        this.setLoading(false)
        let error = false
        if (Array.isArray(jcTmpErrorList)) {
          const isError = (jcTmpErrorList || [])
            .map(f => f.severity)
            .filter(f => !!f)

          if (isError.length > 0) this.setState({ errorData: jcTmpErrorList })
          if (isError.find(f => f === '1' || f === 1)) error = true
        }
        if (!error) {
          message.info('Data Saved')

          this.setState({ editInfo: freeEditEngine.generateInitialEditInfo() })

          this.onRetrieve({
            selectedUnits,
            setVisibleUnitSelection,
            autoRetrieve,
            selectedDate,
          })
          this.props.onInsertEvent(false)
          this.props.onInsertEvent(showInsertComp)
          afterSaveTask && afterSaveTask()
          // if (!showInsertComp) {
          this.setInsertData(this.props.defaultInsertData || {})
        }
        // }
      }
    )
  }

  saveData = ({
    selectedUnits,
    setVisibleUnitSelection,
    autoRetrieve,
    selectedDate,
  }) => {
    const { apiTargetInfo, saveTask, afterSaveTask } = this.props
    const { data, editInfo } = this.state

    if (editInfo.updated.length <= 0 && editInfo.added.length <= 0) {
      message.warning('Please, modify data for save ')
      return
    }

    // let saveData = [
    //   ...editInfo.updated.map(d => ({ ...d, modificationInfo: null })),
    //   ...editInfo.added.map(d => ({ ...d, modificationInfo: null })),
    // ]
    let saveData = freeEditEngine.applyEdits({
      data: data.filter(d => d.updated),
      editInfo,
    })
    saveData = this.props.modifySaveDataBeforeSave
      ? this.props.modifySaveDataBeforeSave(
          saveData,
          this.validateData,
          this.props.CLIENT
        )
      : saveData

    if (saveData === false) {
      return
    }
    this.setLoading(true)
    saveTask(apiTargetInfo)(saveData).fork(
      this.props.setError,
      jcTmpErrorList => {
        this.setLoading(false)
        let error = false
        if (Array.isArray(jcTmpErrorList)) {
          const isError = (jcTmpErrorList || [])
            .map(f => f.severity)
            .filter(f => !!f)

          if (isError.length > 0) this.setState({ errorData: jcTmpErrorList })
          if (isError.find(f => f === '1' || f === 1)) error = true
        }
        if (!error) {
          message.info('Data Saved')
          this.setState({ editInfo: freeEditEngine.generateInitialEditInfo() })
          // this.setLoading(false)
          this.onRetrieve({
            selectedUnits,
            setVisibleUnitSelection,
            autoRetrieve,
            selectedDate,
          })
          afterSaveTask && afterSaveTask()
        }
      }
    )
  }

  deleteData = ({
    selectedUnits,
    autoRetrieve,
    setVisibleUnitSelection,
    selectedDate,
  }) => {
    const { apiTargetInfo, deleteTask, afterSaveTask } = this.props
    const { selected } = this.state
    if (!(selected.selectedRows && selected.selectedRows.length > 0)) {
      message.error('Please , Select Row to Delete')
      return
    }
    this.setLoading(true)
    let saveData = selected.selectedRows
    saveData = this.props.modifySaveDataBeforeSave
      ? this.props.modifySaveDataBeforeSave(saveData)
      : saveData
    deleteTask(apiTargetInfo)(saveData).fork(
      this.props.setError,
      jctmpError => {
        this.setLoading(false)
        if (Array.isArray(jctmpError)) {
          if (isErrorContains(jctmpError)) {
            this.setState({ errorData: jctmpError })
            return
          }
        }
        message.info('Data Saved')
        this.setState({
          editInfo: freeEditEngine.generateInitialEditInfo(),
          selected: { selectedRows: [] },
        })

        this.onCriteriaChnage()
        this.onRetrieve({
          selectedUnits,
          autoRetrieve,
          setVisibleUnitSelection,
          selectedDate,
        })
        afterSaveTask && afterSaveTask()
      }
    )
  }

  onInsertCancel = _ => {
    this.props.onInsertEvent && this.props.onInsertEvent(false)
    this.setState({ insertData: this.props.defaultInsertData || {} })
  }

  render() {
    const {
      data,
      editInfo,
      enterNew = false,
      fuzzyFilter = '',
      selected,
    } = this.state
    // const {error, setError}=useContext(ErrorContext)
    const {
      autoRetrieve = true,
      withUnitSelection = false,
      withDatePicker = false,
      header,
      exportHeader,
      heightOffset,
      altBy,
      sortOptions,
      initialSortOptions,
      widthOffset = 50,
      totalWidth,
      withoutModify = false,
      insertComp,
      onInsertEvent = _ => _,
      insertCompHeight = 0,
      allowInsert = true,
      autoFixColByKey = true,
      headerRowHeight = 30,
      sortEnabled = true,
      loading,
      isAdminScreen = true,
      screenCriteria = _ => [],
      withDelete = true,
      retrieveLabel = 'Retrieve',
      extraUnitSelectionProps = _ => ({}),
      titleProps = {},
      showDatePickerOnEdit = false,
    } = this.props

    const applyEditChange = editInfo => {
      // const allChanges = [...editInfo.added, ...editInfo.updated]
      // const changedUnit = allChanges.map(c => c.unit)
      const modData = data.map(d => {
        if (editInfo.updatedMap.get(d)) {
          return {
            ...editInfo.updatedMap.get(d),
            modificationInfo: { user: null, modDate: moment() },
          }
        } else {
          return d
        }
      })
      // setData(modData)
      // setEditInfo(editInfo)
      this.setState({ data: modData, editInfo })
    }

    const editRow = editInfo => {
      const modData = data.map(d => {
        if (editInfo.updatedMap.get(d)) {
          return {
            ...editInfo.updatedMap.get(d),
            // modificationInfo: { user: null, modDate: moment() },
            modificationInfo: undefined,
            updated: true,
          }
        } else {
          return d
        }
      })

      let editData = editInfo.updated
      editData = editData.map(d => ({
        ...d,
        // modificationInfo: { user: null, modDate: moment() },
        modificationInfo: undefined,
      }))
      //      setData(modData)
      //    setEditInfo({ ...editInfo, updated: editData })
      this.setState({
        data: modData,
        editInfo: { ...editInfo, updated: editData },
      })
    }
    const isEditableComp = ({ header, rowData }) => {
      if (header.ident === 'modifier' || header.ident === 'modifiedDate')
        return false
      if (isAdminScreen)
        return (
          this.props.permitActions.includes(Actions.CHANGE_PERMISSIONS) &&
          (rowData.inserted || !header.isKey || header.isEditable || false)
        )
      else if (this.props.isEditableGrid)
        return this.props.isEditableGrid({ header, rowData })
      else {
        if (rowData.inserted) return true
        if (header.isEditable === false) return false
        if (header.isKey === true) return false
        return true
        // return rowData.inserted || header.isEditable || !header.isKey || false
      }
    }

    const getGridWidth = defaultWidth => {
      const gridWidth = header.reduce((a, b) => a + (b.width || 100), 0)
      return totalWidth || (gridWidth < defaultWidth ? gridWidth : defaultWidth)
    }

    const dateEditor = props => {
      const { data, header, rowIndex, style, getInputProps, cancelEdit } = props
      const { onChange, value } = getInputProps({ refKey: 'innerRef' })
      return (
        <DatePicker
          value={value ? moment(value) : null}
          onChange={date => {
            const newEditInfo = freeEditEngine.updateRow({
              editInfo,
              currentRow: data[rowIndex],
              editedRow: {
                ...data[rowIndex],
                [header.ident]: date ? date.format(header.dataFormat) : null,
              },
            })
            editRow(newEditInfo)
            data[rowIndex][header.ident] = date
              ? date.format(header.dataFormat)
              : null
            onChange({
              target: { value: date ? date.format(header.dataFormat) : date },
            })
          }}
          style={{
            ...style,
            padding: '0px 2px',
          }}
          format={header.displayFormat}
          size="small"
          onOpenChange={status => {
            if (!status) cancelEdit()
          }}
          allowClear={header.allowClear}
          suffixIcon={null}
          // bordered={false}
          open
        />
      )
    }

    const dateTimeEditor = props => {
      const { data, header, rowIndex, style, getInputProps, cancelEdit } = props
      const { onChange, value } = getInputProps({ refKey: 'innerRef' })
      return (
        <DatePicker
          value={value ? moment(value) : null}
          showTime={{
            format: 'h:mm',
            defaultValue: moment('00:00', 'HH:mm'),
          }}
          onChange={date => {
            const newEditInfo = freeEditEngine.updateRow({
              editInfo,
              currentRow: data[rowIndex],
              editedRow: {
                ...data[rowIndex],
                [header.ident]: date ? date.format(header.dataFormat) : null,
              },
            })
            editRow(newEditInfo)
            data[rowIndex][header.ident] = date
              ? date.format(header.dataFormat)
              : null
            onChange({
              target: { value: date ? date.format(header.dataFormat) : date },
            })
          }}
          style={{
            ...style,
            padding: '0px 2px',
          }}
          format={header.displayFormat}
          size="small"
          onOpenChange={status => {
            if (!status) cancelEdit()
          }}
          allowClear={header.allowClear}
          suffixIcon={null}
          // bordered={false}
        />
      )
    }

    const cellRenderWithDate = props => {
      const { reactVirtualizedProps, gridToolProps } = props
      const style = reactVirtualizedProps.style
      const type = gridToolProps.headers[reactVirtualizedProps.columnIndex].type

      return defaultVirtualizedCellRender({
        ...props,
        style,
        editRender:
          type === 'date'
            ? dateEditor
            : type === 'date-time'
            ? dateTimeEditor
            : undefined,
      })
    }

    const fileProps = {
      name: 'file',
      // action: `${this.props.apiTargetInfo.baseUrl}/interface-data/import`,
      action:
        `${this.props.apiTargetInfo.baseUrl}/` + `${this.props.importUrl}`,
      method: 'POST',
      data: this.props.importData || {},
      headers: getAuthorization(this.props.apiTargetInfo),
      ...getCredentials(this.props.apiTargetInfo),
    }

    return (
      <UnitSelectionContext.Consumer>
        {({ selectedUnits, setVisibleUnitSelection }) => (
          <DatePickerContext.Consumer>
            {({ selectedDate, setSelectedDate }) => (
              <div
                style={{
                  backgroundColor: '#f0f2f5',
                  marginLeft: '20px',
                  marginRight: '20px',
                }}
              >
                {this.state.errorData && this.state.errorData.length > 0 && (
                  <JcTmpErrorDialog
                    visible={this.state.errorData.length > 0}
                    errors={this.state.errorData}
                    closeErrorPrompt={_ => this.setState({ errorData: [] })}
                  />
                )}
                {withUnitSelection && (
                  <UnitSelection
                    setData={() => this.onCriteriaChnage()}
                    retrieveData={({ selUnits }) =>
                      this.onRetrieve({
                        selectedUnits: selUnits,
                        setVisibleUnitSelection,
                        autoRetrieve: false,
                        selectedDate,
                      })
                    }
                    {...extraUnitSelectionProps()}
                  />
                )}
                <CriteriaRow>
                  <Title
                    style={{
                      marginRight: '15px',
                      marginBottom: '5px',
                      ...titleProps,
                    }}
                  >
                    {this.props.title}
                  </Title>
                  {this.props.withDatePickerTitle && (
                    <div style={{ marginRight: '2px' }}>
                      {this.props.withDatePickerTitle}
                    </div>
                  )}
                  {withDatePicker && (
                    <DatePicker
                      allowClear={false}
                      format="MM/DD/YYYY"
                      value={selectedDate}
                      onChange={d => {
                        setSelectedDate(d)
                        this.setState({ selectedDate: d })
                        this.onCriteriaChnage()
                      }}
                    />
                  )}
                  {screenCriteria &&
                    screenCriteria(
                      this.state,
                      this.props,
                      selectedUnits,
                      this.onCriteriaChnage,
                      selectedDate,
                      pr =>
                        this.onRetrieve({
                          selectedUnits,
                          setVisibleUnitSelection,
                          autoRetrieve,
                          selectedDate,
                          ...pr,
                        })
                    )}
                  <Button
                    loading={loading}
                    onClick={() =>
                      this.onRetrieve({
                        selectedUnits,
                        setVisibleUnitSelection,
                        autoRetrieve,
                        selectedDate,
                      })
                    }
                    style={{ marginLeft: '10px' }}
                    type="primary"
                    icon="database"
                  >
                    {retrieveLabel}
                  </Button>

                  {((allowInsert &&
                    isAdminScreen &&
                    this.props.permitActions.includes(
                      Actions.CHANGE_PERMISSIONS
                    )) ||
                    (!isAdminScreen && allowInsert)) && (
                    <Button
                      loading={loading}
                      onClick={_ => onInsertEvent(true)}
                      icon="plus-circle"
                      style={{ backgroundColor: '#e6f7ff', marginLeft: '10px' }}
                    >
                      Insert
                    </Button>
                  )}
                  {((!withoutModify &&
                    isAdminScreen &&
                    this.props.permitActions.includes(
                      Actions.CHANGE_PERMISSIONS
                    )) ||
                    (!withoutModify && !isAdminScreen)) && (
                    <Button
                      loading={loading}
                      style={{
                        marginLeft: '10px',
                        // color: '#FFFFFF',
                        // backgroundColor:
                        //   editInfo.updated.length > 0 || editInfo.added.length > 0
                        //     ? '#52c41a'
                        //     : 'lightgray',
                      }}
                      disabled={
                        editInfo.updated.length <= 0 &&
                        editInfo.added.length <= 0
                      }
                      onClick={() =>
                        this.saveData({
                          selectedUnits,
                          setVisibleUnitSelection,
                          autoRetrieve,
                          selectedDate,
                        })
                      }
                      icon="edit"
                      type="primary"
                    >
                      Update
                    </Button>
                  )}

                  {((!withoutModify &&
                    withDelete &&
                    isAdminScreen &&
                    this.props.permitActions.includes(
                      Actions.CHANGE_PERMISSIONS
                    )) ||
                    (!withoutModify && !isAdminScreen)) && (
                    <Popconfirm
                      title="Are you sure?"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={() =>
                        this.deleteData({
                          selectedUnits,
                          autoRetrieve,
                          setVisibleUnitSelection,
                          selectedDate,
                        })
                      }
                      // disabled={selected.selectedRows && selected.selectedRows.length <= 0}
                      placement="topRight"
                      // disabled
                    >
                      <Button
                        loading={loading}
                        icon="delete"
                        style={{
                          marginLeft: '10px',
                          // color: '#FFFFFF',
                          // backgroundColor: '#FF0000',
                        }}
                        type="danger"
                        disabled={
                          selected.selectedRows &&
                          selected.selectedRows.length <= 0
                        }
                      >
                        Remove
                      </Button>
                    </Popconfirm>
                  )}

                  {((!withoutModify &&
                    this.props.withImport &&
                    isAdminScreen &&
                    this.props.permitActions.includes(
                      Actions.CHANGE_PERMISSIONS
                    )) ||
                    (!withoutModify &&
                      !isAdminScreen &&
                      this.props.withImport)) && (
                    <Upload
                      {...fileProps}
                      beforeUpload={_ => this.setLoading(true)}
                      onChange={data => {
                        if (data.file.status === 'done') {
                          this.setLoading(false)

                          if (
                            data.file.response &&
                            data.file.response.restfulStatus &&
                            data.file.response.restfulStatus === 'FAILURE'
                          ) {
                            this.props.setError(data.file.response)
                          } else {
                            if (!isErrorContains(data.file.response)) {
                              message.success('File imported successfully')
                              this.props.importSucessRetrieve &&
                                this.onRetrieve({
                                  selectedUnits,
                                  setVisibleUnitSelection,
                                  autoRetrieve,
                                  selectedDate,
                                })
                            }

                            this.setState({ errorData: data.file.response })
                          }
                        }
                        if (data.file.status === 'error') {
                          this.setLoading(false)
                          this.props.setError(data.file.response)
                        }
                      }}
                      multiple={false}
                      showUploadList={false}
                    >
                      <Button icon="upload" style={{ marginLeft: '10px' }}>
                        Import
                      </Button>
                    </Upload>
                  )}
                  <div css={{ flex: '1 1 0px' }} />
                  {this.props.extraCriteriaAfterButton &&
                    this.props.extraCriteriaAfterButton({
                      selectedRows: this.state.selected,
                      data,
                      selectedUnits,
                      editInfo,
                      onRetrieve: _ =>
                        this.onRetrieve({
                          selectedUnits,
                          setVisibleUnitSelection,
                          autoRetrieve,
                          selectedDate,
                        }),
                      apiTargetInfo: this.props.apiTargetInfo,
                      setSpinning: this.props.setSpinning,
                      loading: this.props.loading,
                      setError: this.props.setError,
                      isEditableAllowed:
                        (!withoutModify &&
                          withDelete &&
                          isAdminScreen &&
                          this.props.permitActions.includes(
                            Actions.CHANGE_PERMISSIONS
                          )) ||
                        (!withoutModify && !isAdminScreen),
                    })}
                  <div css={{ flex: '1 1 0px' }} />
                  <Input.Search
                    placeholder="Filter"
                    value={fuzzyFilter}
                    css={{
                      marginLeft: '10px',
                      marginRight: '10px',
                      flex: '0 0 200px',
                      ...(this.props.searchStyle || {}),
                    }}
                    onChange={e =>
                      this.setState({ fuzzyFilter: e.target.value })
                    }
                  />
                  <ExportComponent
                    getData={_ =>
                      exportDataComponent(this.GridRef, data, fuzzyFilter)
                    }
                    data={data}
                    headers={(exportHeader || header || []).map(d => ({
                      ...d,
                      rowHeaderBackgroundColor: '#eee',
                    }))}
                    fileName={this.props.exportTitle || this.props.title}
                    btnStyle={{ marginRight: '10px' }}
                    disabled={data.length <= 0}
                  />
                </CriteriaRow>

                {this.props.extraCriteria &&
                  this.props.extraCriteria({
                    onCriteriaChnage: this.onCriteriaChnage,
                  })}
                {allowInsert && insertComp && (
                  <CriteriaRow style={{ marginTop: '10px', padding: '5px' }}>
                    {insertComp({
                      validateData: this.validateData,
                      retrieve: () =>
                        this.onRetrieve({
                          selectedUnits,
                          setVisibleUnitSelection,
                          autoRetrieve,
                          selectedDate,
                        }),
                      data,
                      setInsertData: this.setInsertData,
                      insertData: this.state.insertData,
                      onAdd: showInsertComp =>
                        this.onAdd({
                          selectedUnits,
                          setVisibleUnitSelection,
                          autoRetrieve,
                          showInsertComp,
                          selectedDate,
                        }),
                      onCancel: this.onInsertCancel,
                    })}
                  </CriteriaRow>
                )}

                <FullHeightSizer
                  heightOffset={
                    heightOffset ||
                    270 -
                      (autoRetrieve ? 50 : 0) +
                      (insertComp ? insertCompHeight : 0)
                  }
                >
                  {({ height, width }) =>
                    data && data.length > 0 ? (
                      <Content style={{ height: height - 20 }}>
                        <Grid
                          ref={this.GridRef}
                          editMode="cell"
                          data={data || []}
                          headers={header.map(e => ({
                            ...e,
                            isFiltered: true,
                          }))}
                          altBy={altBy}
                          altBgColor="#ebebeb"
                          onEditInfoChange={editInfo =>
                            enterNew
                              ? applyEditChange(editInfo)
                              : editRow(editInfo)
                          }
                          editInfo={editInfo}
                          render={virtualizedGridRenderer({
                            autoFixColByKey,
                            rowHeaderRender,
                            cellRender: showDatePickerOnEdit
                              ? cellRenderWithDate
                              : undefined,
                            height: height - 40,
                            width: getGridWidth(width - widthOffset),
                            headerRowHeight,
                          })}
                          fuzzyFilter={fuzzyFilter}
                          onSelectionChange={selected => {
                            this.selectionChange(selected)
                          }}
                          initialSortOptions={initialSortOptions || sortOptions}
                          sortOptions={sortOptions}
                          sortEnabled={sortEnabled}
                          isEditable={isEditableComp}
                          selectionType={this.props.selectionType || 'row'}
                          selectionMode={this.props.selectionMode || 'single'}
                        />
                      </Content>
                    ) : !autoRetrieve ? (
                      <Content style={{ height: '200px' }}>
                        <Empty
                          imageStyle={{ paddingTop: '30px' }}
                          description={
                            (withDatePicker || screenCriteria) &&
                            data.length === 0
                              ? 'Data Not Available'
                              : selectedUnits && selectedUnits.length <= 0
                              ? this.props.noDataText
                                ? this.props.noDataText
                                : 'Please select units'
                              : 'Please click on retrieve button to retrieve data'
                          }
                        />
                      </Content>
                    ) : (
                      <Content style={{ height: '200px' }}>
                        <Empty imageStyle={{ paddingTop: '30px' }} />
                      </Content>
                    )
                  }
                </FullHeightSizer>
              </div>
            )}
          </DatePickerContext.Consumer>
        )}
      </UnitSelectionContext.Consumer>
    )
  }
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  permitActions: getPermitActions(state),
  validYearRange: getValidYearRange(state),
  CLIENT: getClientInfo(state),
})

const WrappedCommonScreen = props => (
  <SpinContext.Consumer>
    {({ spinning, setSpinning }) => (
      <ErrorContext.Consumer>
        {({ error, setError }) => (
          <CommonScreen
            loading={spinning}
            setSpinning={setSpinning}
            error={error}
            setError={setError}
            {...props}
          />
        )}
      </ErrorContext.Consumer>
    )}
  </SpinContext.Consumer>
)

export default connect(mapStateToProps)(WrappedCommonScreen)
